import { Create } from 'react-admin'

import CollectionForm, { getDefaultCollectionPrice } from './CollectionCodeForm'

const transform = data => ({
  ...data,
  price:
    data.price === undefined || data.price === null || data.price === ''
      ? getDefaultCollectionPrice(data.items)
      : data.price,
})

const CollectionCreate = props => (
  <Create redirect="list" {...props} transform={transform}>
    <CollectionForm />
  </Create>
)

export default CollectionCreate
